import React from "react";

/**
 * Sidebar facet panel — shows a list of selectable category/brand chips with
 * counts. Extracted from InfoShopPage.jsx (v3.8.5) as part of the
 * component decomposition. Preserves the original data-testid contract:
 * `${testidPrefix}-${slugified-name}` for each row.
 */
export default function FacetPanel({ title, items, active, onPick, testidPrefix }) {
  if (!items?.length) return null;
  const fmtCount = (n) => {
    if (n == null) return "";
    if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(2)}M`;
    if (n >= 1_000) return `${(n / 1_000).toFixed(1)}k`;
    return String(n);
  };
  return (
    <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
      <div className="px-4 py-3 border-b border-slate-100 text-[11px] uppercase tracking-[0.18em] font-bold text-slate-500">
        {title}
      </div>
      <div className="max-h-72 overflow-y-auto">
        {items.map((it) => {
          const isActive = active === it.name;
          return (
            <button
              key={it.name}
              onClick={() => onPick(it.name)}
              data-testid={`${testidPrefix}-${it.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className={`w-full px-4 py-2.5 text-left flex items-center justify-between border-b border-slate-50 hover:bg-slate-50 ${isActive ? "bg-[#0072CE]/5" : ""}`}
            >
              <span className={`text-sm ${isActive ? "text-[#0072CE] font-semibold" : "text-slate-700"}`}>{it.name}</span>
              <span
                className="text-[11px] font-mono text-slate-500 tabular-nums"
                title={`${it.count.toLocaleString()} SKUs in UniBuy™ catalog`}
              >
                {fmtCount(it.count)}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
